<template>
  <div class="-mt-6">

    <Wrapper
      bgColor="#d1faeb"
      inset
      wrapperHeight="viewport"
    >
      <div class="py-12">

        <div class="flex flex-col items-center justify-center">
          <h1 class="text-4xl md:text-6xl text-center mb-3" v-html="title"></h1>
          <div class="text-center mb-3">
            Crafted by RentalKit.ai
          </div>
          <div class="text-center bg-white rounded-full px-4 py-2 text-sm font-bold">
            Prepared on {{today}}
          </div>
        </div>

        <div class="flex items-center justify-center my-20">
          <ol class="list-decimal text-lg">
            <li>
              <a href="#property-details">Property Details</a>
            </li>
            <li>
              <a href="#comparables">Comparable Properties</a>
            </li>
            <li>
              <a href="#estimate">Estimated Rent</a>
            </li>
          </ol>
        </div>
      </div>
    </Wrapper>

    <PropertyDetails id="property-details" />

    <Comparables id="comparables" />

    <EstimatedRent id="estimate" />

  </div>
</template>

<script>
import dayjs from 'dayjs';

import Button from './Button.vue';
import Comparables from './Comparables.vue';
import EstimatedRent from './EstimatedRent.vue';
import Fees from './Fees.vue';
import Map from './Map.vue';
import PropertyDetails from './PropertyDetails.vue';
import Wrapper from './Wrapper.vue';

export default {
  name: 'Estimate',
  components: {
    Button,
    Comparables,
    EstimatedRent,
    Fees,
    Map,
    PropertyDetails,
    Wrapper,
  },
  mounted() {
    this.initSmoothScroll();
  },
  computed: {
    title() {
      return `Rent<br />Estimate`;
    },
    today() {
      return this.estimate ? dayjs(this.estimate.post_date).format('MMMM D, YYYY') : null;
    },
  },
  data() {
    return {
      estimate: window.app.estimate,
    };
  },
  methods: {
    initSmoothScroll() {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(event) {

          event.preventDefault();
          const target = document.querySelector(this.getAttribute('href'));
          if (target) {
            const offset = document.getElementById('header')?.clientHeight;
            const targetPosition = target.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: targetPosition - offset,
              behavior: 'smooth'
            });
          }
        });
      });
    },
  },
}
</script>

<style scoped lang="scss">

</style>
